<template>
	<div :class="[
		width || 'w-[542px]', height || 'h-10',
		rounded || 'rounded-01_5',
		'flex items-center pl-3 pr-2 py-[9px] gap-1.5 bg-background-basic-1 overflow-hidden ',
		isFocused ? 'border-2 border-primary-3' : 'border border-content-basic-4',
	]">
		<!-- Search Icon -->
		<SearchIcon class="shrink-0" width="24" height="24" color="text-content-basic-1" />
		<!-- Input Field -->
		<input :type="inputtype || 'text'" :placeholder="placeholder" :value="modelValue"
			class="w-full p-0 font-inter-boby-2 text-content-basic-1 placeholder:text-content-basic-3 border-none"
			@input="$emit('update:modelValue', $event.target.value)" @focus="isFocused = true"
			@blur="isFocused = false" />
	</div>
</template>

<script setup>
import { ref } from 'vue'
import SearchIcon from './icon/search.vue'

defineProps({
	modelValue: [String, Number],
	placeholder: String,
	inputtype: {
		type: String,
		default: 'text',
	},
	width : { type : String},
	height : { type : String },
	rounded : { type : String },
})
defineEmits(['update:modelValue'])

const isFocused = ref(false)
</script>

<style scoped>
input:focus {
	outline: none;
	box-shadow: none;
	/* ring 효과도 제거 */
}
</style>